// extracted by mini-css-extract-plugin
export var leftAlign = "_2l-2";
export var popper = "_2l-0";
export var subtitle = "_2l-1";